module.exports = __webpack_public_path__ + "static/img/i48_df61.11d6102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/i48_df61.png
// module id = v+kc
// module chunks = 101